import { Link } from "react-router-dom";

export const ButtonPage = () => {
  return (
    <div className="btn_bg fixed p-center w-[100vw] h-[100vh] flex justify-center items-center">
      <Link className="mx-16" to="/emotion">
        <img className="w-[520px]" src="/imgs/etc/emotionButton.png" alt="" />
      </Link>
      <Link className="mx-16" to="/chatbot">
        <img className="w-[520px]" src="/imgs/etc/chatBotButton.png" alt="" />
      </Link>
    </div>
  );
};
